// 收钱吧 return_url 落地页：免登录独立页（微信/支付宝钱包浏览器内打开），
// 已加入 permission.ts 的 whiteListRouters 白名单
export default [
  {
    path: '/payment/result',
    name: 'PaymentResult',
    component: () => import('@/pages/payment-result/index.vue'),
    meta: {
      title: {
        zh_CN: '支付结果',
        en_US: 'Payment Result',
      },
      hidden: true,
    },
  },
];
